/* 
 * Export component file to be used on project
*/

import NpsNumber from './NpsNumber';
export default NpsNumber;